import * as type from './resourcesActionTypes.js';

export const loadPosts = (page, limit, order, category) => ({
  type: type.LOAD_POSTS,
  page,
  limit,
  order,
  category,
});

export const loadPostCategories = () => ({
  type: type.LOAD_CATEGORIES,
});

export const loadFeaturedBlog = () => ({
  type: type.LOAD_FEATURED_BLOG,
});

export const setPosts = (value) => ({
  type: type.SET_POSTS,
  value,
});

export const setCategories = (value) => ({
  type: type.SET_CATEGORIES,
  value,
});

export const setIsLoading = (value) => ({
  type: type.SET_IS_LOADING,
  value,
});

export const setTotalPosts = (value) => ({
  type: type.SET_TOTAL_POSTS,
  value,
});

export const resetPosts = () => ({
  type: type.RESET_POSTS,
});

export const resetCategories = () => ({
  type: type.RESET_CATEGORIES,
});

export const setLoadMoreState = (value) => ({
  type: type.SET_LOAD_MORE,
  value,
});

export const setFeaturedBlog = (value) => ({
  type: type.SET_FEATURED_BLOG,
  value,
});
